// extracted by mini-css-extract-plugin
export default {"element":"SideBar_element__iY9AF","sidebar":"SideBar_sidebar__dasUp","active":"SideBar_active__uEMKO","content":"SideBar_content__skvGF"};